var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5375 3.125V15.1625H1.4625V3.125V2.975H1.3125H0.65V1.65H4.5625H4.7125V1.5V0.8375H9.2875V1.5V1.65H9.4375H13.35V2.975H12.6875H12.5375V3.125ZM2.7875 13.6875V13.8375H2.9375H11.0625H11.2125V13.6875V3.125V2.975H11.0625H2.9375H2.7875V3.125V13.6875ZM6.0375 4.9V11.9125H4.7125V4.9H6.0375ZM9.2875 4.9V11.9125H7.9625V4.9H9.2875Z",
    fill: "#163567",
    stroke: "#F6F6FA",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBin);
export default __webpack_public_path__ + "static/media/small-bin.6576d534e42ca9833d00fa0e5b01c1ad.svg";
export { ForwardRef as ReactComponent };